import Typography from '@mui/material/Typography';

const InfoRow = ({ label, value }) => (
    <Typography variant="body2">
      <strong>{label}:</strong> {value ?? '—'}
    </Typography>
  );


  export default InfoRow;